export const environment = {
  production: true,
  apiBaseUrl: "https://dev-backend.0docs.ai/api",
  wsUrl: "https://dev-backend.0docs.ai"
};
